<script>
  export let progress = 0;
</script>

<div style="width: {progress}%"></div>

<style>
div {
  background-color: #edebed;
  height: 32px;
  box-shadow: 2px 2px 6px #fff;
  width: 0%;
}
</style>